import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: (theme.vars ?? theme).palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

function Wishlist(props) {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [wishlistImgs, setWishlistImgs] = useState([]);

  useEffect(() => {
    axios
      .post(`${baseURL}/get-product-images`, {
        productIds: props.userWishlist, // Example product IDs
      })
      .then((response) => {
        setWishlistImgs(response.data); // [{ id: 1, prod_img: 'img1.jpg' }, ...]
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      {props?.userWishlist == null || props?.userWishlist?.length === 0 ? (
        <i>
          Your wishlist is feeling a little lonely. Start adding items you love
          and they’ll show up here!
        </i>
      ) : (
        <Grid container spacing={1}>
          {wishlistImgs.map((item, index) => (
            <Grid size={{ xs: 4, md: 2 }} key={index}>
              <Link
                to={`/product/${item.prod_id}`}
                style={{ textDecoration: "none" }}
              >
                {" "}
                <img
                  className="zoom-hover"
                  src={`${JSON.parse(item.prod_image)[0]}?w=400&h=600&fit=crop`}
                  alt={item.prod_name}
                  style={{
                    width: 200,
                    height: 300,
                    objectFit: "contain",
                  }}
                />
              </Link>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}

export default Wishlist;
